import { Component } from '@angular/core'
import { Router } from '@angular/router'

import { ApiCiecStatsService, CiecStats } from '../data/services/api/api-ciec-stats.service'
import { HomeDashboardService } from '../data/services/view/home-dashboard.service'
import { AuthService } from '@data/services/modules/auth/auth.service'

@Component({
  selector: 'app-home-dashboard',
  templateUrl: './home-dashboard.component.html',
  styleUrls: ['./home-dashboard.component.scss'],
})
export class HomeDashboardComponent {
  leasesCount: number = 0
  walletAmount: number = 0
  walletAmountWithoutAccesories: number = 0
  residuary: number = 0
  dataLoaded: boolean = false

  // ADR-0032 · Fase E7 — telemetría de magic links CIEC.
  // `null` cuando el backend respondió 403 (rol sin permission `clients.get-all`)
  // o cuando aún no cargó. La card muestra "—" en ese caso.
  ciecStats: CiecStats | null = null

  constructor(
    public authService: AuthService,
    public dashboardService: HomeDashboardService,
    private router: Router,
    private ciecStatsService: ApiCiecStatsService,
  ) {
    this.loadData()
  }

  loadData() {
    Promise.all([this.getWalletAmount(), this.getResiduary(), this.getCiecStats()]).then(() => {
      setTimeout(() => {
        this.dataLoaded = true
      }, 1500)
    })
  }

  getWalletAmount() {
    return this.dashboardService.walletAmount().subscribe((data) => {
      this.leasesCount = data.data.leaseCount
      this.walletAmount = data.data.wallet
      this.walletAmountWithoutAccesories = data.data.walletWithoutAccessories
    })
  }

  getResiduary() {
    return this.dashboardService.residuary().subscribe((data) => {
      this.residuary = data.data
    })
  }

  getCiecStats() {
    return new Promise<void>((resolve) => {
      this.ciecStatsService.getStats(30).subscribe((stats) => {
        this.ciecStats = stats
        resolve()
      })
    })
  }

  /**
   * ADR-0032 — % de conversión link → CIEC recibida en los últimos 30 días.
   * Devuelve string como '67%' o '—' si no hay datos / API rechazó.
   */
  get ciecConversionLabel(): string {
    if (!this.ciecStats || this.ciecStats.created === 0) return '—'
    const pct = Math.round(this.ciecStats.conversionRate * 100)
    return `${pct}%`
  }

  //* B-075: el numerador son las recibidas (`byOutcome.received`), no las «usadas».
  get ciecRatioLabel(): string {
    if (!this.ciecStats) return 'Conversión CIEC'
    return `Conversión CIEC (${this.ciecStats.byOutcome?.received ?? 0}/${this.ciecStats.created} · ${this.ciecStats.period.days}d)`
  }

  /** B-075 · «N con rechazo · N agotadas»; vacío si no hay stats. */
  get ciecIssuesLabel(): string {
    const byOutcome = this.ciecStats?.byOutcome
    if (!byOutcome) return ''
    return `${byOutcome.rejected} con rechazo · ${byOutcome.exhausted} ${byOutcome.exhausted === 1 ? 'agotada' : 'agotadas'}`
  }

  // Navigation methods for dashboard cards and components
  navigateToLease() {
    this.router.navigate(['/lease'])
  }

  navigateToWallet() {
    this.router.navigate(['/wallet'])
  }

  navigateToActive() {
    this.router.navigate(['/active'])
  }

  navigateToPayment() {
    this.router.navigate(['/payment'])
  }
}
